import React from "react"
import styled from "styled-components"
import {fmt} from "@indebted/fmt"
import {Link as RouterLink} from "@reach/router"
import {Link, TableCell, TableRow} from "@material-ui/core"
import WarningIcon from "@material-ui/icons/Warning"

function Row({file}) {
	return (
		<TableRow hover={true}>
			<TightCell>{fmt.timestamp(file.LastModified)}</TightCell>
			<TightCell>{file.Client.Name}</TightCell>
			<TightCell>{file.Directory}</TightCell>
			<MetricCell>{fmt.bytes(file.Size)}</MetricCell>
			<FileLink file={file} />
		</TableRow>
	)
}

function FileLink({file}) {
	const params = {
		ClientID: file.Client.ID,
		Directory: file.Directory,
		Filename: file.Name,
	}

	const path = `/client-file?${new URLSearchParams(params).toString()}`
	const label = file.IsErrWithContents ? <strong>{file.Name}</strong> : file.Name

	return (
		<WideCell>
			<Link component={RouterLink} to={path}>
				{file.Size > 0 && file.IsErrWithContents && (
					<>
						<WarningIcon fontSize="small" style={{verticalAlign: "bottom"}} color="error" />{" "}
					</>
				)}
				{label}
			</Link>
		</WideCell>
	)
}

const MonospaceCell = styled(TableCell)`
	font-family: Courier;
`

const TightCell = styled(MonospaceCell)`
	width: 1px;
`

const MetricCell = styled(TightCell)`
	text-align: right;
`

const WideCell = styled(MonospaceCell)`
	white-space: normal;
	width: 100%;
`

export {Row}
